<template>
    <q-page class="q-pa-md">

        <q-dialog v-model="dialogVisualizador" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class=" items-center q-pb-none">
                    <div class="row">
                        <div class="col-3">
                            <div class="text-h6">Vista previa Cotización</div>
                        </div>
                        <div class="col-6 text-center">
                            <q-btn-group push>
                                <q-btn push label="Desacargar" color="primary" icon="download"
                                    @click="descargarPDF()" />
                                <q-btn push label="Asignar Cotización" color="primary" icon="mdi-send"
                                    @click="PostCotizacion()" />
                            </q-btn-group>
                        </div>
                        <div class="col-3 text-right">
                            <q-btn icon="close" flat round dense v-close-popup />
                        </div>
                    </div>
                </q-card-section>
                <q-card-section>
                    <!-- <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDF" />
                    </div> -->
                    <VisualizadorPDF></VisualizadorPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogVistaPrevia" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="  items-center q-pb-none">
                    <div class="row">
                        <div class="col-4">
                            <div class="text-h6">Vista previa Cotización aq</div>
                        </div>
                        <div class="col-4 text-center">
                            <q-btn-group push>
                                <q-btn push label="Desacargar" color="primary" icon="download"
                                    @click="descargarPDFPrevia()" />
                            </q-btn-group>
                        </div>
                        <div class="col-4 text-right">
                            <q-btn icon="close" flat round dense v-close-popup />
                        </div>
                    </div>

                </q-card-section>
                <q-card-section>
                    <!-- <div class="text-center">
                        <q-btn icon="download" flat label="Descargar PDF" color="primary" @click="descargarPDFPrevia" />
                    </div> -->
                    <VistasPreviasPDF></VistasPreviasPDF>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogValoresCotizar" persistent>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Valores a Cotizar</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <div class="row q-col-gutter-md">

                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Cotizar" color="primary" @click="mandaCotizar()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogRechazarSolicitud" persistent>
            <q-card v-if="selectSolicitud != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirmas el rechazo de la solicitud del día
                                <strong>{{ selectSolicitud.fecha_solicitud }}</strong>, por el cliente
                                <strong>{{ selectSolicitud.rfc + " " + selectSolicitud.razon_social }}</strong>,
                                <strong>{{ selectSolicitud.marca + " " + selectSolicitud.modelo + " " +
                                    selectSolicitud.version }}</strong>.? Indique el motivo de rechazo:</span>
                        </div>
                    </div>
                    <div class="row col-12">
                        <q-input class="full-width" label="Motivo" v-model="selectSolicitud.notas" outlined autogrow />
                    </div>
                    <div class="row col-12 doc-note ">
                        <div class="doc-note__title full-width">Aviso</div>
                        <div class="">Se le notifcara al cliente el motivo de rechazo de su solicitud.</div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="PutRechazarSolicitud()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogFinalizarSolicitud" persistent>
            <q-card v-if="selectSolicitud != null">
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h6 q-ml-lg">¿Confirmas la aceptación de la solicitud del día
                                <strong>{{ selectSolicitud.fecha_solicitud }}</strong>, por el cliente
                                <strong>{{ selectSolicitud.rfc + " " + selectSolicitud.razon_social }}</strong>,
                                <strong>{{ selectSolicitud.marca + " " + selectSolicitud.modelo + " " +
                                    selectSolicitud.version }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al aceptar la solicitud, el cliente será notificado y podrá visualizar las
                            cotizaciones asignadas para elegir la que mejor se adapte a sus necesidades.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" v-close-popup />
                    <q-btn label="Aceptar" color="primary" @click="UpdateSoliicitudAceptada()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog class="rounded-brders" v-model="dialogDetalles" persistent>
            <q-card v-if="selectSolicitud" style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Detalles de la Solicitud</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-stepper v-model="step" class="shadow-0" bordered ref="stepper" header-nav color="primary"
                        animated>
                        <!-- INFORMACION DEL CLIENTE Y DE SUS DOCUMENTOS -->
                        <q-step :name="1" title="Documentación" icon="settings" :done="done1">
                            <q-card class="shadow-0" v-if="selectSolicitud != null">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6">Datos del Solicitante</div>
                                </q-card-section>
                                <q-separator class="q-my-md" />
                                <q-card-section>
                                    <div class="row q-col-gutter-md">
                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Fecha de solicitud" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="event" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.fecha_solicitud }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>
                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Código Postal" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="mdi-map-marker" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.cp }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>
                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="RFC" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="person" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.rfc }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>
                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Razón Social  o Nombre de la Persona"
                                                stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="person" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.razon_social }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>

                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Uso del CFDI" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="person" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.usoCfdi }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>
                                        <div class="col-12 col-md-6  ">
                                            <q-field color="teal" filled label="Régimen Fiscal" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="person" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.regimen_fiscal }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>

                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Método de Pago" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="mdi-cash" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.metodoPago }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>

                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Forma de Pago" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="mdi-cash" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.formaPago }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>

                                        <div class="col-12 col-md-6  ">
                                            <q-field color="teal" filled label="Moneda" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="mdi-cash" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.moneda }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>

                                        <div class="col-12 col-md-6 ">
                                            <q-field color="teal" filled label="Email" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="email" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.email }}
                                                    </div>
                                                </template>
                                            </q-field>
                                        </div>
                                        <div class="col-12  col-md-6 ">
                                            <q-field color="teal" filled label="Método de Pago" stack-label>
                                                <template v-slot:prepend>
                                                    <q-icon name="phone" color="primary" />
                                                </template>
                                                <template v-slot:control>
                                                    <div class="self-center full-width no-outline" tabindex="0">{{
                                                        selectSolicitud.telefono }}
                                                    </div>
                                                </template>
                                            </q-field>

                                        </div>
                                        <!-- <div class="col-12 col-md-8">
                                            <q-list bordered separator>
                                                <q-item v-for="(file, index) in documentosUsuario" :key="index">
                                                    <q-item-section avatar>
                                                        <q-icon name="insert_drive_file" color="primary" />
                                                    </q-item-section>
                                                    <q-item-section class="col-2 gt-sm">
                                                        <q-item-label class="q-mt-sm">{{ file.fecha_creacion
                                                        }}</q-item-label>
                                                    </q-item-section>
                                                    <q-item-section top>
                                                        <q-item-label lines="1"
                                                            class="q-mt-xs text-body2 text-weight-bold text-primary text-uppercase">
                                                            <span>{{ file.tipo }}</span>
                                                        </q-item-label>
                                                        <q-item-label lines="1">
                                                            <span class="text-weight-medium"
                                                                v-if="file.existe == true">{{
                                                                    file.nombre_archivo }} </span>
                                                            <span class="text-weight-medium" v-else>No se ha
                                                                cargado</span>
                                                            <span class="text-grey-8"> - Documento</span>
                                                        </q-item-label>
                                                    </q-item-section>
                                                    <q-item-section top side v-if="file.existe == true">
                                                        <div class="q-gutter-xs">
                                                            <q-btn icon="mdi-file-document" flat round color="primary"
                                                                @click="descargarArchivo(file)" />

                                                              
                                                        </div>
                                                    </q-item-section>
                                                </q-item>
                                            </q-list>
                                        </div> -->
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-step>

                        <!-- INFORMACION DEL VEHICULO -->
                        <q-step :name="2" title="Modelo Vehiculo" icon="create_new_folder" :done="done2">
                            <q-card class="shadow-0" v-if="selectSolicitud != null">
                                <q-card-section class="row items-center q-pb-none">
                                    <div class="text-h6"> {{ selectSolicitud.marca }} {{ selectSolicitud.modelo }} {{
                                        selectSolicitud.version }}</div>
                                </q-card-section>
                                <q-separator class="q-my-md" />
                                <q-card-section>
                                    <div class="row q-col-gutter-md">
                                        <div class="col-12 col-md-4">
                                            <div class="row q-col-gutter-md">
                                                <div class="col-12 ">
                                                    <q-field color="teal" filled label="Marca" stack-label>
                                                        <template v-slot:prepend>
                                                            <q-icon name="directions_car" color="primary" />
                                                        </template>
                                                        <template v-slot:control>
                                                            <div class="self-center full-width no-outline" tabindex="0">
                                                                {{
                                                                    selectSolicitud.marca }}
                                                            </div>
                                                        </template>
                                                    </q-field>
                                                </div>
                                                <div class="col-12 ">
                                                    <q-field color="teal" filled label="Versión" stack-label>
                                                        <template v-slot:prepend>
                                                            <q-icon name="directions_car" color="primary" />
                                                        </template>
                                                        <template v-slot:control>
                                                            <div class="self-center full-width no-outline" tabindex="0">
                                                                {{
                                                                    selectSolicitud.version }}
                                                            </div>
                                                        </template>
                                                    </q-field>
                                                </div>
                                                <div class="col-12 ">
                                                    <q-field color="teal" filled label="Año" stack-label>
                                                        <template v-slot:prepend>
                                                            <q-icon name="directions_car" color="primary" />
                                                        </template>
                                                        <template v-slot:control>
                                                            <div class="self-center full-width no-outline" tabindex="0">
                                                                {{
                                                                    selectSolicitud.anio }}
                                                            </div>
                                                        </template>
                                                    </q-field>

                                                </div>
                                                <div class="col-12">
                                                    <q-field color="teal" filled label="Color" stack-label>
                                                        <template v-slot:prepend>
                                                            <q-icon name="directions_car" color="primary" />
                                                        </template>
                                                        <template v-slot:control>
                                                            <div class="self-center full-width no-outline" tabindex="0">
                                                                {{
                                                                    selectSolicitud.color }}
                                                            </div>
                                                        </template>
                                                    </q-field>
                                                </div>
                                                <div class="col-12 ">
                                                    <q-field color="teal" filled label="Tipo de Vehiculo" stack-label>
                                                        <template v-slot:prepend>
                                                            <q-icon name="directions_car" color="primary" />
                                                        </template>
                                                        <template v-slot:control>
                                                            <div class="self-center full-width no-outline" tabindex="0">
                                                                {{ selectSolicitud.color }}
                                                            </div>
                                                        </template>
                                                    </q-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-8">
                                            <!-- <span>{{ selectSolicitud }}</span> -->
                                            <q-carousel v-model="carouselSlide"
                                                v-if="selectSolicitud.imagenes && selectSolicitud.imagenes.length"
                                                animated swipeable arrows infinite control-color="primary"
                                                height="280px">
                                                <q-carousel-slide v-for="(img, index) in selectSolicitud.imagenes"
                                                    :key="index" :name="index">
                                                    <q-img :src="img.imagBase64" :alt="'Imagen ' + (index + 1)"
                                                        spinner-color="primary"
                                                        style="height: 250px; border-radius: 8px; margin: auto;"
                                                        contain />
                                                </q-carousel-slide>
                                            </q-carousel>
                                        </div>
                                    </div>

                                    <!-- <q-separator /> -->

                                    <!-- <div class="q-my-sm">
                                        <div class="col-12 q-mb-md">
                                            <q-icon name="directions_car" color="primary" size="sm" class="q-mr-sm" />
                                            <span class="text-subtitle2 text-grey-7">Año:</span>
                                            <div class="text-body1 q-pl-lg q-ml-lg">
                                                {{ selectSolicitud.anio }}
                                            </div>
                                            <q-separator />
                                        </div>

                                        <q-chip icon="directions_car" color="blue-2" text-color="black">
                                            Año: {{ selectSolicitud.anio }}
                                        </q-chip>
                                        <q-chip icon="directions_car" color="blue-2" text-color="black">
                                            Color: {{ selectSolicitud.color }}
                                        </q-chip>
                                        <q-chip icon="directions_car" color="blue-2" text-color="black">
                                            Tipo: {{ selectSolicitud.tipovehiculo }}
                                        </q-chip>
                                        <q-chip icon="attach_money" color="green-2" text-color="black">
                                            Precio: ${{ parseFloat(selectSolicitud.precio).toLocaleString() }}
                                        </q-chip>
                                    </div>
                                    <q-separator /> -->

                                </q-card-section>
                            </q-card>
                        </q-step>

                        <!-- INFORMACION Y CARGA DE COTIZACIONES -->
                        <q-step :name="3" title="Cotizaciones" icon="add_comment" :done="done3">
                            <div class="row items-center">
                                <div class="text-h6">Cotizaciones</div>
                                <q-space />
                                <q-btn
                                    v-if="selectSolicitud.estatus != 'EnProcesoContrato' && selectSolicitud.estatus != 'ContratoVigente'"
                                    dense flat round :icon="mostrarUploader ? 'remove' : 'add'" color="primary"
                                    @click="mostrarUploader = !mostrarUploader">
                                    <q-tooltip>{{ mostrarUploader ? 'Ocultar uploader' : 'Agregar archivos'
                                    }}</q-tooltip>
                                </q-btn>
                            </div>
                            <div v-show="mostrarUploader" class="row q-my-md q-col-gutter-sm">
                                <div class="col-12 col-md-12">
                                    <q-select dense outlined v-model="selectAgencia" :options="listaAgencias"
                                        label="Agencia" color="primary" option-label="razon_social" clearable
                                        options-selected-class="text-deep-blue">
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-car" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.rfc + ' - ' + scope.opt.razon_social" />
                                                    <q-item-label caption>{{ scope.opt.representante }}</q-item-label>
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>

                                <div class="col-3">
                                    <q-input prefix="$" v-model="valoresCot.precio" dense outlined label="Precio"
                                        class="full-width" mask="#.##" fill-mask="0" reverse-fill-mask
                                        input-class="text-right" />
                                </div>
                                <div class="col-3">
                                    <q-input prefix="$" v-model="valoresCot.anticipo" dense outlined label="Anticipo"
                                        class="full-width" mask="#.##" fill-mask="0" reverse-fill-mask
                                        input-class="text-right" />
                                </div>
                                <div class="col-3">
                                    <q-input prefix="$" v-model="valoresCot.seguro" dense outlined label="Seguro"
                                        class="full-width" mask="#.##" fill-mask="0" reverse-fill-mask
                                        input-class="text-right" />
                                </div>
                                <div class="col-3">
                                    <q-input prefix="$" v-model="valoresCot.placas" dense outlined label="Placas"
                                        class="full-width" mask="#.##" fill-mask="0" reverse-fill-mask
                                        input-class="text-right" />
                                </div>
                                <div class="col-6">

                                    <div class="q-gutter-sm">
                                        <q-radio v-model="calcularVarlorRes" val="-1" label="Sin valor Residual" />
                                        <q-radio v-model="calcularVarlorRes" val="0" label="Calcular en Automatico" />
                                        <q-radio v-model="calcularVarlorRes" val="1" label="Ingresar Valor Residual" />
                                    </div>
                                </div>
                                <div class="col-3">
                                    <q-input v-if="calcularVarlorRes == '1'" prefix="$" v-model="valoresCot.valorres"
                                        dense outlined label="Valor Residual con I.V.A." class="full-width" mask="#.##"
                                        fill-mask="0" reverse-fill-mask input-class="text-right" />
                                </div>

                                <div class="col-3">
                                    <q-select v-model="valoresCot.plazo" dense outlined label="Plazos"
                                        :options="itemsPlazos" option-label="label" option-value="value" emit-value
                                        map-options class="full-width">
                                        <template v-slot:after>
                                            <q-btn round color="primary" flat icon="mdi-calculator"
                                                @click="mandaCotizar()" />
                                        </template>
                                    </q-select>
                                </div>
                                <!-- <div class="col-12 col-md-12">
                                    <q-file v-model="archivoSeleccionadoArrendafit" dense outlined
                                        label="Cotización ArrendaFit" class="full-width" accept=".pdf">
                                    </q-file>
                                </div> -->
                                <!-- <div class="col-12 col-md-6">
                                    <q-file v-model="archivoSeleccionado" dense outlined label="Cotización Agencia"
                                        class="full-width">
                                    </q-file>
                                </div> -->

                                <!-- <div class="col-12 col-md-12 row">
                                    <q-space />
                                    <q-btn icon="save" outline label="Enviar" color="primary"
                                        @click="PostCotizacion()" />
                                </div> -->
                            </div>
                            <q-separator class="q-my-md" />
                            <q-list v-if="listaCotizaciones.length != 0" bordered separator class="q-mt-lg">
                                <q-item v-for="(file, index) in listaCotizaciones" :key="index">
                                    <q-item-section avatar>
                                        <q-icon name="insert_drive_file" color="primary" />
                                    </q-item-section>
                                    <q-item-section class="col-2 gt-sm">
                                        <q-item-label class="q-mt-sm">{{ file.fecha_creacion }}</q-item-label>
                                    </q-item-section>
                                    <q-item-section top>
                                        <q-item-label lines="1"
                                            class="q-mt-xs text-body2 text-weight-bold text-primary text-uppercase">
                                            <span>{{ file.rfc + ' - ' + file.razon_social }}</span>
                                        </q-item-label>
                                        <q-item-label caption lines="2">
                                            {{ file.representante + ', ' + file.correo + ', ' + file.telefono + ', ' +
                                                file.domicilio_fiscal }}
                                        </q-item-label>
                                        <q-separator />
                                        <!-- <q-item-label lines="1">
                                            <span class="text-weight-medium">{{ file.nombre_archivo_agencia }}</span>
                                            <span class="text-grey-8"> - Cotización de la agencia</span>
                                        </q-item-label>
                                        <q-separator /> -->
                                        <q-item-label lines="1">
                                            <span class="text-weight-medium">{{ file.nombre_archivo_arrendafit }}</span>
                                            <span class="text-grey-8"> - Cotización de ArrendaFit</span>
                                        </q-item-label>
                                        <q-item-label lines="1">
                                            <q-chip size="sm" color="primary" text-color="white"
                                                icon="mdi-currency-usd">
                                                Precio: {{ file.precio }}
                                            </q-chip>
                                            <q-chip size="sm" color="primary" text-color="white"
                                                icon="mdi-currency-usd">
                                                Anticipo: {{ file.anticipo }}
                                            </q-chip>
                                            <q-chip size="sm" color="primary" text-color="white"
                                                icon="mdi-currency-usd">
                                                Seguro: {{ file.seguro }}
                                            </q-chip>
                                            <q-chip size="sm" color="primary" text-color="white"
                                                icon="mdi-currency-usd">
                                                Enplacamiento: {{ file.placas }}
                                            </q-chip>
                                            <q-chip size="sm" color="primary" text-color="white" icon="mdi-calendar">
                                                Plazos: {{ file.plazo }}
                                            </q-chip>
                                            <q-chip size="sm" color="primary" text-color="white"
                                                icon="mdi-currency-usd">
                                                V.R.: {{ file.valorres }}
                                            </q-chip>
                                        </q-item-label>
                                    </q-item-section>
                                    <q-item-section side>
                                        <div class="q-gutter-xs">
                                            <q-btn icon="mdi-file-document" flat round color="primary"
                                                @click="VerArchivo(file)" />
                                            <q-btn icon="mdi-whatsapp" flat round color="green"
                                                @click="notificar(file)" />
                                            <q-btn v-if="selectSolicitud.estatus == 'CotizandoSolicitud'" icon="delete"
                                                flat round color="negative" @click="UpdateCotizacion(file)" />
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </q-step>
                    </q-stepper>
                    <div class="row doc-note" v-if="selectSolicitud.estatus == 'EnProcesoContrato'">
                        <div class="doc-note__title full-width">Aviso</div>
                        <p class=""> La solicitud ya cuenta con una cotizacion aceptada por el Cliente, podra verla en
                            la lista de
                            cotizaciones para el proceso de contrato.</p>
                    </div>
                </q-card-section>
                <q-card-actions class="row justify-between"
                    v-if="selectSolicitud.estatus != 'Aceptada' && selectSolicitud.estatus != 'EnProcesoContrato' && selectSolicitud.estatus != 'ContratoVigente'">
                    <q-btn flat @click="rechazarSolicitud()" color="red" label="Rechazar Solicitud" />
                    <q-btn flat @click="finalizarSolicitud()" class="q-ml-sm" color="primary"
                        label="Finalizar Solicitud" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class="col-12">
                <q-table dense title="Solicitudes" class="shadow-1" :data="solicitudes" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline color="primary" icon="mdi-refresh" label="Consultar"
                            @click="GetSolicitudesAdministrador()" no-caps class="q-my-md" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <!-- <q-td key="acciones" :props="props">
                                <q-btn flat round color="red" icon="mdi-cancel" @click="cancelarItem(props.row)" />
                            </q-td> -->
                            <q-td key="rfc" :props="props" @click="verItem(props.row)">{{ props.row.rfc }}</q-td>
                            <q-td key="razon_social" :props="props" @click="verItem(props.row)">{{
                                props.row.razon_social
                            }}</q-td>
                            <q-td key="email" :props="props" @click="verItem(props.row)">{{ props.row.email }}</q-td>
                            <q-td key="telefono" :props="props" @click="verItem(props.row)">{{ props.row.telefono
                            }}</q-td>
                            <q-td key="fecha_solicitud" :props="props" @click="verItem(props.row)">{{
                                props.row.fecha_solicitud }}</q-td>
                            <q-td key="marca" :props="props" @click="verItem(props.row)">{{ props.row.marca }}</q-td>
                            <q-td key="modelo" :props="props" @click="verItem(props.row)">{{ props.row.modelo }}</q-td>
                            <q-td key="anio" :props="props" @click="verItem(props.row)">{{ props.row.anio }}</q-td>
                            <q-td key="color" :props="props" @click="verItem(props.row)">{{ props.row.color }}</q-td>
                            <q-td key="tipovehiculo" :props="props" @click="verItem(props.row)">{{
                                props.row.tipovehiculo }}</q-td>
                            <q-td key="version" :props="props" @click="verItem(props.row)">{{ props.row.version
                            }}</q-td>
                            <q-td key="fecha_aceptacion" :props="props" @click="verItem(props.row)">{{
                                props.row.fecha_aceptacion }}</q-td>
                            <q-td key="estatus" :props="props">
                                <q-badge v-if="props.row.estatus == 'Enviada'" color="blue"
                                    label="PendienteDeRevisión" />
                                <q-badge v-if="props.row.estatus == 'CotizandoSolicitud'" color="purple"
                                    :label="props.row.estatus" />


                                <q-badge v-if="props.row.estatus == 'Rechazada'" color="red"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'Aceptada'" color="green"
                                    label="EsperandoRespuestaCliente" />

                                <q-badge v-if="props.row.estatus == 'EnProcesoContrato'" color="green"
                                    :label="props.row.estatus" />
                                <q-badge v-if="props.row.estatus == 'ContratoVigente'" color="black"
                                    :label="props.row.estatus" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'
import moment from 'moment';
import { generarCotizacionPDF } from "../../PDF/CotizacionPDF.JS";
import VisualizadorPDF from "../../PDF/VisualizadorPDF.vue";
import VistasPreviasPDF from "../../PDF/VistasPreviasPDF.vue";
export default {
    components: {
        VisualizadorPDF,
        VistasPreviasPDF
    },
    data() {
        return {
            calcularVarlorRes: '-1',
            carouselSlide: 0,
            done1: false,
            done2: false,
            done3: false,
            loading: false,
            solicitudes: [],
            columns: [
                // { name: 'acciones', label: 'Acciones', field: 'acciones', align: 'center', sortable: true },
                { name: 'rfc', label: 'RFC', field: 'rfc', align: 'center', sortable: true },
                { name: 'razon_social', label: 'Razón Social o Nombre de la Persona', field: 'razon_social', align: 'center', sortable: true },
                { name: 'email', label: 'Email', field: 'email', align: 'center', sortable: true },
                { name: 'telefono', label: 'Teléfono', field: 'telefono', align: 'center', sortable: true },
                { name: 'fecha_solicitud', label: 'Fecha de Solicitud', field: 'fecha_solicitud', align: 'center', sortable: true },
                { name: 'marca', label: 'Marca', field: 'marca', align: 'center', sortable: true },
                { name: 'modelo', label: 'Modelo', field: 'modelo', align: 'center', sortable: true },
                { name: 'anio', label: 'Año', field: 'anio', align: 'center', sortable: true },
                { name: 'color', label: 'Color', field: 'color', align: 'center', sortable: true },
                { name: 'tipovehiculo', label: 'Tipo Vehiculo', field: 'tipovehiculo', align: 'center', sortable: true },
                { name: 'version', label: 'Versión', field: 'version', align: 'center', sortable: true },
                { name: 'fecha_aceptacion', label: 'Fecha de Aceptación', field: 'fecha_solicitud', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },

            step: 1,
            dialogDetalles: false,
            mostrarUploader: false,
            selectAgencia: null,
            selectSolicitud: null,
            listaAgencias: [],
            archivo_base64: '',
            nombre_archivo: '',
            listaCotizaciones: [],
            documentosUsuario: [],
            slide: 1,
            dialogFinalizarSolicitud: false,
            dialogRechazarSolicitud: false,
            // archivoSeleccionado: null,
            archivoSeleccionadoArrendafit: null,
            dialogValoresCotizar: false,
            itemsPlazos: [
                { label: '12 Meses', value: '12' },
                { label: '24 Meses', value: '24' },
                { label: '36 Meses', value: '36' },
                { label: '48 Meses', value: '48' },
            ],
            dialogVisualizador: false,
            dialogVistaPrevia: false
        }
    },
    async mounted() {
        const logoURL = require('../../../assets/logo_top.png')
        this.logoBase64 = await this.cargarImagenComoBase64(logoURL);
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
        valoresCot() {
            return this.$store.state.auth.objetoValoresCotizacion;
        },
        objetoCot() {
            return this.$store.state.auth.objetoPostCotizacion;
        }

    },
    created() {
        this.GetSolicitudesAdministrador();
    },
    methods: {
        async verItem(item) {
            console.log(item)
            this.selectSolicitud = item
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Consultando detalles. Espere...', messageColor: 'white' })
            await this.GetProveedores();
            // await this.GetDocumentosUsuario();
            await this.GetCotizaciones();
            this.$q.loading.hide()
            this.dialogDetalles = true
        },
        async PutRechazarSolicitud() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Rechazando solicitud. Espere...', messageColor: 'white' })
            let objeto = {
                _id: this.selectSolicitud._id,
                estatus: 'Rechazada',
                fecha: new Date().toLocaleString('es-MX'),
                notas: this.selectSolicitud.notas,
            }
            try {
                let respuesa = await axios.put('Catalogos/UpdateSolicitudRechazada/', objeto)
                console.log(respuesa)
                this.selectSolicitud.estatus = "Rechazada"
                const index = this.solicitudes.findIndex(p => p._id === this.selectSolicitud._id)
                this.$set(this.solicitudes, index, { ...this.selectSolicitud })
                this.$q.loading.hide()
                this.inicializar()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `La solicitud fue rechazada con exito.` });

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Error al rechazar la solicitud.` });
                console.log(error)
            }
        },
        async UpdateSoliicitud() {
            if (this.selectSolicitud.estatus == 'Enviada') {
                try {
                    let respuesa = await axios.put('Catalogos/UpdateSolicitud/' + this.selectSolicitud._id + '/CotizandoSolicitud')
                    console.log(respuesa)
                    this.selectSolicitud.estatus = "CotizandoSolicitud"
                    const index = this.solicitudes.findIndex(p => p._id === this.selectSolicitud._id)
                    this.$set(this.solicitudes, index, { ...this.selectSolicitud })
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async UpdateSoliicitudAceptada() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Aceptando solicitud. Espere...', messageColor: 'white' })
            let objeto = {
                _id: this.selectSolicitud._id,
                estatus: 'Aceptada',
                fecha: new Date().toLocaleString('es-MX'),
            }
            try {
                let respuesa = await axios.put('Catalogos/UpdateSolicitudAceptada/', objeto)
                console.log(respuesa)
                this.selectSolicitud.estatus = "Aceptada"
                const index = this.solicitudes.findIndex(p => p._id === this.selectSolicitud._id)
                this.$set(this.solicitudes, index, { ...this.selectSolicitud })
                this.$q.loading.hide()
                this.inicializar()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `La solicitud fue aceptada con exito.` });

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Error al aceptar la solicitud.` });
                console.log(error)
            }
        },
        async PostCotizacion() {
            // const archivoArrendafit = this.archivoSeleccionadoArrendafit;

            // if (!archivoArrendafit) {
            //     this.$q.notify({
            //         color: 'negative',
            //         message: 'Debes seleccionar un archivo.',
            //         position: 'top-right'
            //     });
            //     return;
            // }

            if (this.valoresCot.precio == 0) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Indique el precio.',
                    position: 'top-right'
                });
                return;
            }



            if (this.valoresCot.seguro == 0) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Indique el precio del seguro.',
                    position: 'top-right'
                });
                return;
            }

            if (this.valoresCot.placas == 0) {
                this.$q.notify({
                    color: 'negative',
                    message: 'Indique el precio del enplacamiento.',
                    position: 'top-right'
                });
                return;
            }
            const base64Arrendafit = this.$store.state.auth.storeBase64Cotizacion
            let nombre_archivo_arrendafit = this.selectSolicitud.rfc + "_" + this.selectSolicitud.razon_social + "_" + this.selectSolicitud.marca + "_" + this.selectSolicitud.modelo + ".pdf";
            let cotizacion_arrendafit = base64Arrendafit;

            let objeto = {
                _id: '',
                _id_usuario: this.selectSolicitud._id_usuario,
                _id_solicitud: this.selectSolicitud._id,
                _id_proveedor: this.selectAgencia._id,
                // cotizacion_agencia: cotizacion_agencia,
                // nombre_archivo_agencia: nombre_archivo_agencia,

                nombre_archivo_arrendafit: nombre_archivo_arrendafit,
                cotizacion_arrendafit: cotizacion_arrendafit,

                anticipo: this.valoresCot.anticipo,
                seguro: this.valoresCot.seguro,
                plazo: this.valoresCot.plazo,
                precio: this.valoresCot.precio,
                placas: this.valoresCot.placas,
                valorres: this.valoresCot.valorres,

                preciototal: this.$store.state.auth.objetoPostCotizacion.preciototal,
                rentamensual: this.$store.state.auth.objetoPostCotizacion.rentamensual,
                iva: this.$store.state.auth.objetoPostCotizacion.iva,
                rentamensualtotal: this.$store.state.auth.objetoPostCotizacion.rentamensualtotal,
                comisionxapertura: this.$store.state.auth.objetoPostCotizacion.comisionxapertura,
                depgarantiarentaadelantada: this.$store.state.auth.objetoPostCotizacion.depgarantiarentaadelantada,
                pagoinicialtotal: this.$store.state.auth.objetoPostCotizacion.pagoinicialtotal,
                valorresidual: this.$store.state.auth.objetoPostCotizacion.valorresidual,
                notaVresidual: this.$store.state.auth.objetoPostCotizacion.notaVresidual,

                fecha_creacion: new Date().toLocaleString('es-MX'),
                usuario_creador: this.adminStore.email,
                estatus: 'Vigente'
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Enviando cotización. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Catalogos/PostCotizacion', objeto)
                console.log(respuesa)
                await this.UpdateSoliicitud();
                await this.GetCotizaciones();
                await this.limpiarCotizacion();
                this.dialogVisualizador = false
                this.$q.loading.hide()
                this.$q.notify({ type: 'positive', position: 'top-right', message: `La cotización se asigno correctamente.` });

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar la cotización.` });
                console.log(error)
            }
        },
        async UpdateCotizacion(item) {
            try {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Eliminando cotización. Espere...', messageColor: 'white' })
                let respuesa = await axios.put('Catalogos/UpdateCotizacion/' + item._id + '/Eliminado')
                console.log(respuesa)
                const index = this.listaCotizaciones.findIndex(p => p._id === item._id)
                if (index !== -1) {
                    this.listaCotizaciones.splice(index, 1)
                }
                this.$q.notify({ type: 'positive', position: 'top-right', message: `La cotización se elimino correctamente.` });
                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al eliminar la cotización, intentelo nuevamente.` });
                console.log(error)
            }
        },
        async GetDocumentosUsuario() {
            this.documentosUsuario = []
            try {
                let respuesa = await axios.get('Documentos/GetDocumentosUsuario/' + this.selectSolicitud._id_usuario)
                console.log(respuesa)
                this.documentosUsuario.push(respuesa.data.documento1)
                this.documentosUsuario.push(respuesa.data.documento2)
                this.documentosUsuario.push(respuesa.data.documento3)
                this.documentosUsuario.push(respuesa.data.documento4)
                this.documentosUsuario.push(respuesa.data.documento5)

            } catch (error) {
                console.log(error)
            }
        },

        async GetSolicitudesAdministrador() {
            this.loading = true
            try {
                let respuesa = await axios.get('Catalogos/GetSolicitudesAdministrador/')
                console.log(respuesa)
                this.solicitudes = respuesa.data
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        async GetProveedores() {
            try {
                let respuesa = await axios.get('Catalogos/GetProveedoresTipo/Agencia')
                console.log(respuesa.data)
                this.listaAgencias = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },

        async GetCotizaciones() {
            try {
                let respuesa = await axios.get('Catalogos/GetCotizaciones/' + this.selectSolicitud._id_usuario + '/' + this.selectSolicitud._id)
                console.log(respuesa.data)
                this.listaCotizaciones = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        convertirABase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        finalizarSolicitud() {
            if (this.listaCotizaciones.length == 0) {
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Para poder finalizar la solicitud debera generar al menos una cotización.` });
                return
            }
            this.dialogFinalizarSolicitud = true
        },
        rechazarSolicitud() {
            this.dialogRechazarSolicitud = true
        },

        descargarArchivo(documento) {
            // const link = document.createElement('a');
            // link.href = documento.cotizacion_agencia;
            // link.download = documento.nombre_archivo_agencia || 'archivo.pdf';
            // link.click();

            const link2 = document.createElement('a');
            link2.href = documento.cotizacion_arrendafit;
            link2.download = documento.nombre_archivo_arrendafit || 'archivo.pdf';
            link2.click();
        },
        async notificar(documento) {
            // console.log(documento)
            // console.log(this.selectSolicitud)
            // this.$store.state.auth.storeBase64Cotizacion = documento.cotizacion_arrendafit
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Enviando notificación por WhatsApp. Espere...', messageColor: 'white' })

            let objeto = {
                id_usuario: this.selectSolicitud._id_usuario,
                mensaje: 'Se envia la Cotizacion correspondiente a ' + documento.plazos + ' del vehiculo ' + this.selectSolicitud.marca + ', ' + this.selectSolicitud.modelo + ', ' + this.selectSolicitud.tipovehiculo + ', ' + this.selectSolicitud.anio + ', ' + this.selectSolicitud.color + ' con un precio de ' + documento.precio + '. Para aceptar la cotización, debera acudir a nuestro sitio Web https://arrendafit.contago.com.mx/',
                base64: documento.cotizacion_arrendafit.split(",")[1]
            }
            try {
                let response = await axios.post('Notificaciones/Notificacion', objeto);
                console.log(response)
                this.$q.loading.hide()
                if (response.data.edopet == '0') {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se envio la notificación.` });
                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar la notificación.` });
                }
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        cancelarItem(item) {
            console.log(item)

        },
        inicializar() {
            this.dialogDetalles = false;
            this.selectAgencia = null;
            this.selectSolicitud = null;
            this.listaCotizaciones = [];
            this.documentosUsuario = [];
            this.dialogFinalizarSolicitud = false
            this.dialogRechazarSolicitud = false
        },
        limpiarCotizacion() {
            this.$store.state.auth.objetoValoresCotizacion = {
                precio: 0,
                anticipo: 0,
                seguro: 0,
                placas: 0,
                plazo: "12",
                valorres: 0
            }
            this.archivoSeleccionadoArrendafit = null
        },
        cargarImagenComoBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image()
                img.crossOrigin = 'Anonymous'
                img.onload = function () {
                    const canvas = document.createElement('canvas')
                    canvas.width = this.width
                    canvas.height = this.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(this, 0, 0)
                    const dataURL = canvas.toDataURL('image/png')
                    resolve(dataURL)
                }
                img.onerror = reject
                img.src = url
            })
        },
        async mandaCotizar() {
            if (this.selectAgencia == null) {
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Indique el proveedor de Agencia.` });
                return
            }

            if (this.calcularVarlorRes == '-1') {
                this.valoresCot.valorres = -1
            }

            if (this.calcularVarlorRes == '0') {
                this.valoresCot.valorres = 0
            }

            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Generando cotización. Espere...', messageColor: 'white' })
            console.log(this.valoresCot)
            try {
                let respuesa = await axios.post('Catalogos/GetCalculos/', this.valoresCot)
                console.log(respuesa)

                this.$store.state.auth.objetoPostCotizacion.preciototal = respuesa.data.preciototal
                this.$store.state.auth.objetoPostCotizacion.rentamensual = respuesa.data.rentamensual
                this.$store.state.auth.objetoPostCotizacion.iva = respuesa.data.iva
                this.$store.state.auth.objetoPostCotizacion.rentamensualtotal = respuesa.data.rentamensualtotal
                this.$store.state.auth.objetoPostCotizacion.comisionxapertura = respuesa.data.comisionxapertura
                this.$store.state.auth.objetoPostCotizacion.depgarantiarentaadelantada = respuesa.data.depgarantiarentaadelantada
                this.$store.state.auth.objetoPostCotizacion.pagoinicialtotal = respuesa.data.pagoinicialtotal
                this.$store.state.auth.objetoPostCotizacion.valorresidual = respuesa.data.valorresidual
                this.$store.state.auth.objetoPostCotizacion.notaVresidual = respuesa.data.notaVresidual
                this.$store.state.auth.objetoPostCotizacion.agente = this.selectAgencia.rfc + ' - ' + this.selectAgencia.razon_social,
                    this.$store.state.auth.objetoPostCotizacion.cliente = this.selectSolicitud.rfc + ' ' + this.selectSolicitud.razon_social,
                    this.$store.state.auth.objetoPostCotizacion.vehiculo = this.selectSolicitud.marca + ' ' + this.selectSolicitud.modelo + " " + this.selectSolicitud.version + " " + this.selectSolicitud.tipovehiculo, this.$store.state.auth.objetoPostCotizacion.precio = this.valoresCot.precio,
                    this.$store.state.auth.objetoPostCotizacion.anticipo = this.valoresCot.anticipo,
                    this.$store.state.auth.objetoPostCotizacion.seguro = this.valoresCot.seguro,
                    this.$store.state.auth.objetoPostCotizacion.placas = this.valoresCot.placas,
                    this.$store.state.auth.objetoPostCotizacion.plazo = this.valoresCot.plazo

                this.dialogVisualizador = true

                this.$q.loading.hide()

            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'error', position: 'top-right', message: `No se pudo realizar la cotización.` });
                console.log(error)
            }
        },
        descargarPDF() {
            const fileName = this.selectSolicitud.rfc + "_" + this.selectSolicitud.razon_social + "_" + this.selectSolicitud.marca + "_" + this.selectSolicitud.modelo + ".pdf";
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },

        descargarPDFPrevia() {
            const fileName = this.selectSolicitud.rfc + "_" + this.selectSolicitud.razon_social + "_" + this.selectSolicitud.marca + "_" + this.selectSolicitud.modelo + ".pdf";
            const link = document.createElement("a");
            link.href = this.$store.state.auth.storeBase64Cotizacion;
            link.download = fileName;
            link.click();
        },
        VerArchivo(documento) {
            // const link2 = document.createElement('a');
            // link2.href = documento.cotizacion_arrendafit;
            // link2.download = documento.nombre_archivo_arrendafit || 'archivo.pdf';
            // link2.click();
            this.$store.state.auth.storeBase64Cotizacion = documento.cotizacion_arrendafit
            this.dialogVistaPrevia = true
        }
    }
}
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>